import { z } from 'zod';

/**
 * Unpadded base64url — the alphabet the browser seam encodes every
 * authenticator byte string in. Standard base64's `+`, `/` and `=` are a
 * second spelling of the same bytes, so a seam that reached for `btoa` is
 * refused at the parse seam on both ends rather than minting a credential id
 * no later lookup could match.
 */
export const base64url = z.string().regex(/^[A-Za-z0-9_-]+$/);
